import * as React from "react";
const SvgSearchSmall = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.037 12.467a5.254 5.254 0 0 1 0-7.428 5.249 5.249 0 0 1 7.426 0 5.254 5.254 0 0 1 0 7.428 5.249 5.249 0 0 1-7.426 0Zm-1.06-8.49a6.755 6.755 0 0 0 0 9.55 6.749 6.749 0 0 0 8.99.5l3.751 3.753a.75.75 0 1 0 1.06-1.06l-3.752-3.755a6.756 6.756 0 0 0-.503-8.987 6.748 6.748 0 0 0-9.546 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgSearchSmall;
